import { createSlice } from "@reduxjs/toolkit";

interface CompaySlice {
  value: string;
}

const env = process.env.REACT_APP_BACKEND_ENVIRONMENT_NAME || ''
const isTestOrLocal = ['test', 'local'].includes(env.toLowerCase())

const initialState: CompaySlice = {
  value: isTestOrLocal ? 'auditech' : '',
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    update: (state, action) => {
      state.value= action.payload
    },
  },

});
export const {update} = companySlice.actions

export default companySlice.reducer;